import styled from 'styled-components';
import { HorizontalScroll as HScroll } from 'src/components/horizontal-scroll';
import { ListItem as ListItemComponent } from 'src/components/list-item';
import { layout } from 'src/components/base';

export const StyledLink = styled.a`
  color: ${p => p.theme.colors.base0};
  text-decoration: underline;
  font-weight: 600;
  margin-left: ${layout.measurements.spacing050};
`;

export const StyledSpan = styled.span`
  color: rgba(255, 255, 255, 0.72);
  font-weight: 600;
`;

export const Box = styled.div`
  max-width: 900px;
  flex-basis: 100%;
  margin-top: ${layout.measurements.spacing100};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  color: ${p => p.theme.colors.base0}; /* For ellipsis color */
`;

export const ListItem = styled(ListItemComponent)`
  text-decoration: underline;
  color: ${p => p.theme.colors.base0};
  &:hover {
    background-color: inherit;
  }
`;

export const HorizontalScroll = styled(HScroll)`
  white-space: nowrap;
  margin-top: ${layout.measurements.spacing075};
  div > ul > li {
    padding: 0;
  }
`;
